import { useEffect } from 'react';
import { useSession } from '@/Recoil/Session/Session';
import { useRoles } from '@/Recoil/Topik/Roles';
import { navigateTo } from '@/Utils/routing';
import RoleSection from '../Components/RoleSection';
import ManagerTable from '../Components/ManagerTable';
import LecturerTable from '../Components/LecturerTable';
import StudentTable from '../Components/StudentTable';
import './index.scss';
import AdminTable from '../Components/AdminTable';

const ROLE_ORDER: Record<string, number> = {
    admin:    4,
    manager:  3,
    lecturer: 1,
    student:  1,
};

function TopikRolesPage() {
    const { session } = useSession();
    const { roles, syncUserRole } = useRoles();

    const userRole = roles[session.email];

    useEffect(() => {
        if (!session.email) {
            navigateTo('/login?redirectTo=/topik/roles');
        }
    }, [session.email]);

    useEffect(() => {
        if (session.email) {
            syncUserRole({ email: session.email });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session.email]);

    const roleLevel = ROLE_ORDER[userRole?.role] ?? 0;

    return (
        <div className="TopikRolesPage">
            <div className="Container">
                <header className="Header">MATE 한국어능력시험 권한 관리</header>

                <RoleSection />

                {roleLevel >= ROLE_ORDER['admin'] && session.email.endsWith('@webtoontoday.com') && <AdminTable />}
                {roleLevel >= ROLE_ORDER['admin'] && <ManagerTable />}
                {roleLevel >= ROLE_ORDER['manager'] && <LecturerTable />}
                {roleLevel >= ROLE_ORDER['manager'] && <StudentTable />}

                {roleLevel < ROLE_ORDER['manager'] && (
                    <div className="NoPermission">권한이 없습니다.</div>
                )}
            </div>
        </div>
    );
}

export default TopikRolesPage;
